import { useCallback } from 'react';

import { SpecialtyLevel } from '@dreryk/egabinet-personnel-frontend-api';

import { assertUnreachable, useTranslate } from '@dreryk/react-common';
import { InteractiveTable, InteractiveTableCellProps } from '@dreryk/react-components';

import { personnelTranslationKeys } from '../../../../../translations';

const specialistLevels: SpecialtyLevel[] = ['LEVEL_1', 'LEVEL_2', 'SPECIALIST', 'PENDING'];

const getLabel = (specialtyLevel?: SpecialtyLevel): string => {
   switch (specialtyLevel) {
      case undefined:
         return '';
      case 'LEVEL_1':
         return personnelTranslationKeys.specialtiesTable.level_1;
      case 'LEVEL_2':
         return personnelTranslationKeys.specialtiesTable.level_2;
      case 'SPECIALIST':
         return personnelTranslationKeys.specialtiesTable.specialist;
      case 'PENDING':
         return personnelTranslationKeys.specialtiesTable.pending;
      default:
         return assertUnreachable(specialtyLevel);
   }
};

const useTriggerLabelExtractor = (): ((specialtyLevel: SpecialtyLevel | undefined) => string) => {
   const translate = useTranslate();
   return useCallback(
      (specialtyLevel) => {
         return translate(getLabel(specialtyLevel));
      },
      [translate]
   );
};

export const SpecialtyLevelSelectCell = (
   props: Omit<InteractiveTableCellProps<SpecialtyLevel>, 'name' | 'testId'>
): JSX.Element => {
   return (
      <InteractiveTable.SelectCell<SpecialtyLevel>
         testId={'specialtyLevel'}
         name={'specialtyLevel'}
         triggerLabelExtractor={useTriggerLabelExtractor()}
         index={props.index}
         validationRules={{
            required: true,
         }}
         defaultValue={props.defaultValue}
      >
         <InteractiveTable.SelectCell.List<SpecialtyLevel> items={specialistLevels}>
            {(item: SpecialtyLevel) => (
               <InteractiveTable.SelectCell.Item item={item} label={getLabel(item)} testId={item} />
            )}
         </InteractiveTable.SelectCell.List>
      </InteractiveTable.SelectCell>
   );
};
